import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function ComingSoonPage() {
  const location = useLocation();
  
  // Logic: Nếu đang ở trang business thì nút Back về Dashboard, còn lại về Trang chủ
  const isBusinessPage = location.pathname.includes('/business');
  const backLink = isBusinessPage ? '/business/dashboard' : '/';
  const backText = isBusinessPage ? 'Quay lại Dashboard' : 'Về Trang chủ';

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F9FAFB',
      fontFamily: '"Inter", sans-serif',
      color: '#111827',
      textAlign: 'center',
      padding: '20px'
    }}>
      
      {/* Icon Animation */}
      <div className="bounce-icon" style={{ fontSize: '64px', marginBottom: '24px' }}>
        🚧
      </div>

      <h1 style={{ fontSize: '36px', fontWeight: '800', marginBottom: '16px', letterSpacing: '-0.5px' }}>
        Tính năng đang phát triển
      </h1>

      <p style={{ fontSize: '16px', color: '#6B7280', maxWidth: '480px', marginBottom: '40px', lineHeight: '1.6' }}>
        Đội ngũ kỹ thuật của SkillMatch đang làm việc chăm chỉ để hoàn thiện tính năng này sớm nhất có thể.
      </p>

      <Link 
        to={backLink} 
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: '#2563EB',
          color: 'white',
          padding: '12px 24px',
          borderRadius: '8px',
          fontWeight: '600',
          textDecoration: 'none',
          boxShadow: '0 4px 6px -1px rgba(37, 99, 235, 0.2)',
          transition: 'all 0.2s'
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = '#1D4ED8'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#2563EB'}
      >
        <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>arrow_back</span>
        {backText}
      </Link>

      <style>{`
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .bounce-icon {
          animation: bounce 2s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
}